// extracted by mini-css-extract-plugin
module.exports = {"title":"_02712f2b3b--title--OAnkX"};